var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Grid from "@mui/material/Grid";
import React, { useEffect, useMemo } from "react";
import { callAPI } from "@/react/lib/common";
import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import makeStyles from "@mui/styles/makeStyles";
import { webshopUserImageUrlCreator } from "@/react/lib/userImageUrlCreators";
import { useAuth } from "@/react/Webshop/providers/AuthProvider";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import FullscreenImageDialog from "@/react/Webshop/Mobile/Components/FullscreenImageDialog";
import { useFullscreenImage } from "@/react/Webshop/Mobile/hooks/useFullscreenImage";
import { useTranslation } from "react-i18next";
import YearbookPoseIcon from "@mui/icons-material/MenuBook";
import Radio from "@mui/material/Radio";
import { pictureIsYearbookPose, pictureIsYearbookPoseForJobYearbookPose, } from "@/react/Webshop/utils/pictureUtils";
import useCopyrightDialog from "@/react/Webshop/hooks/useCopyrightDialog";
const useStyles = makeStyles((theme) => ({
    list: {
        width: "100%",
        overflow: "auto",
        alignItems: "center",
        listStyle: "none",
        margin: 0,
        padding: 0,
        flexGrow: 1,
        display: "flex",
    },
    listItem: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    iconButtonContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        color: theme.palette.secondary.main,
        "& > .MuiButtonBase-root": {
            position: "absolute",
            left: 0,
            top: 0,
        },
    },
    iconButtonBackground: {
        position: "absolute",
        left: "12px",
        top: "12px",
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        backgroundColor: "white",
    },
    favorite: {},
    container: {
        display: "inline-block",
        position: "relative",
        "& > img": {
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            border: `1px solid ${theme.palette.primary.main}`,
            backgroundColor: "white",
            display: "block",
            boxSizing: "border-box",
        },
    },
    isYearbookPoseContainer: {
        "& > img": {
            border: `4px solid ${theme.palette.secondary.main}`,
        },
    },
}));
const YearbookPoseSelector = ({ pictureSet, jobYearbookPose, }) => {
    const { setYearbookPose } = usePictureSets();
    const classes = useStyles();
    const { user } = useAuth();
    const { open, fullscreenImage, origin, openImage, closeImage, updatePicture, } = useFullscreenImage();
    const [t] = useTranslation();
    const { getCopyrightTriggerProps, copyrightDialog } = useCopyrightDialog();
    console.log("Current picture set", pictureSet);
    useEffect(() => {
        console.log("Picture changed, update copy");
        updatePicture(pictureSet.pictures);
    }, [pictureSet.pictures]);
    const handleSetYearbookPose = (picture) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield callAPI(`/api/webshop/user/picture-sets/${pictureSet.subject.uuid}/yearbook-pose`, "POST", {
            subject_uuid: pictureSet.subject.uuid,
            picture_uuid: picture.uuid,
            job_yearbook_pose_uuid: jobYearbookPose.uuid,
        });
        setYearbookPose(pictureSet.subject.uuid, picture.clientRef, jobYearbookPose.uuid);
    });
    const initialYearbookPoseUuid = useMemo(() => {
        var _a;
        const subjectYearbookPose = (_a = pictureSet.yearbookPoses) === null || _a === void 0 ? void 0 : _a.find((syp) => syp.jobYearbookPoseUuid === jobYearbookPose.uuid);
        let fav = null;
        if (subjectYearbookPose) {
            fav = pictureSet.pictures.find((p) => p.clientRef === subjectYearbookPose.pictureClientRef);
        }
        return fav === null || fav === void 0 ? void 0 : fav.uuid;
        // Note: We only depend on pictureSet.uuid as we don't want the selected picture to jump to top when selecting a new one
    }, [pictureSet.uuid]);
    const sortedPictures = useMemo(() => {
        const pics = pictureSet.pictures.filter((p) => p.pictureType === "IP");
        if (initialYearbookPoseUuid) {
            const idx = pics.findIndex((p) => p.uuid === initialYearbookPoseUuid);
            if (idx > 0) {
                const [pose] = pics.splice(idx, 1);
                return [pose, ...pics];
            }
        }
        return pics;
    }, [pictureSet.pictures, initialYearbookPoseUuid]);
    if (!user) {
        return React.createElement("div", null, "Loading");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2 },
            sortedPictures.map((picture) => (React.createElement(Grid, { key: picture.uuid, size: { xs: 6, sm: 4, md: 3 }, className: classes.listItem },
                React.createElement(Picture, { pictureSet: pictureSet, picture: picture, jobYearbookPose: jobYearbookPose, user: user, openImage: openImage, onSetYearBookPose: handleSetYearbookPose, imageContextMenuProps: getCopyrightTriggerProps() })))),
            React.createElement(FullscreenImageDialog, { open: open, onClose: closeImage, transformOrigin: origin, picture: fullscreenImage, actionIcon: React.createElement(YearbookPoseIcon, null), actionText: fullscreenImage &&
                    pictureIsYearbookPose(fullscreenImage, pictureSet)
                    ? t("Current yearbook pose") || ""
                    : t("Set as yearbook pose") || "", actionHandler: (picture) => {
                    handleSetYearbookPose(picture);
                    closeImage();
                } }),
            copyrightDialog)));
};
function Picture({ picture, pictureSet, onSetYearBookPose, openImage, jobYearbookPose, imageContextMenuProps, }) {
    console.log("Keywords", picture.uuid, picture.keywords);
    const classes = useStyles();
    const isYearbookPose = pictureIsYearbookPoseForJobYearbookPose(picture, pictureSet, jobYearbookPose);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${classes.container} ${isYearbookPose ? classes.isYearbookPoseContainer : ""}` },
            React.createElement("img", Object.assign({ src: webshopUserImageUrlCreator(picture.uuid, 320) }, (imageContextMenuProps !== null && imageContextMenuProps !== void 0 ? imageContextMenuProps : {}), { onClick: (e) => openImage(e, picture) })),
            React.createElement("div", { className: classes.iconButtonContainer },
                React.createElement("div", { className: classes.iconButtonBackground }),
                React.createElement(Radio, { checked: isYearbookPose, onClick: () => onSetYearBookPose(picture), icon: React.createElement(RadioButtonUncheckedIcon, null), checkedIcon: React.createElement(RadioButtonCheckedIcon, null) })))));
}
export default YearbookPoseSelector;
